// 服务器行业
import { getPartitioningChild } from '@/utils/api'

export default {
  state: {
    // 服务器细分市场
    serverMarketSegmentList: [],
  },
  getters: {},
  mutations: {
    // 设置服务器细分市场
    setServerMarketSegmentList(state, data) {
      state.serverMarketSegmentList = [...data]
    },
  },
  actions: {
    // 获取服务器细分市场
    async getServerMarketSegmentList({ commit }) {
      let [err, res] = await getPartitioningChild(7)
      if (err) return
      // 保存车型列表
      commit('setServerMarketSegmentList', res)
    },
  }
}
